import { distance } from "@turf/distance";
import { point as createPoint } from "@turf/helpers";
import { LatLng } from "common/utils/Route";
import { IStation } from "dataSources/Typicode/stations";
import { useCallback } from "react";

const SEARCH_RADIUS = 100; // km

export const useFilterStationsByPoint = () => useCallback((referencePoints: LatLng[], stations: IStation[]) => 
    referencePoints.map(({ lng, lat }) => {
        const from = createPoint([lng, lat]);

        const filteredStations = stations.filter((station) => {
            const to = createPoint([
                station.coordinates.longitude,
                station.coordinates.latitude,
            ]);

            const distanceKM = distance(from, to, { units: "kilometers" });
            return 0 <= distanceKM && distanceKM < SEARCH_RADIUS;
        });

    return filteredStations;
}), []);
